import {transform} from '@diplodoc/cut-extension';

export = transform({bundle: false});
